import angular from 'angular';
import timeline from './timeline';
import timelineChecks from './timelineChecks';

export default angular
  .module('components.timeline', [])
  .component('timeline', timeline)
  .component('timelineChecks', timelineChecks).name;
